import type { TranslationInterface } from '.';

export const ChineseSimplifiedLanguage: TranslationInterface = {
  write_a_message_placeholder: '写一条消息...',
  your_issue_has_been_resolved: '您的问题已解决！',
  new_conversation: '新对话',
  welcome_screen_title: '欢迎使用我们的客服聊天',
  welcome_screen_description:
    '我们随时为您提供帮助！开始对话，我们会尽快回复您。',
  your_name_placeholder: '您的姓名',
  your_email_placeholder: '您的电子邮件地址',
  start_chat_button: '联系客服',
  start_chat_button_loading: '连接中...',
  i_need_more_help: '我需要更多帮助',
  this_was_helpful: '这很有帮助',
  optional: '可选',
  no_conversations_yet: '暂无对话',
  back_to_conversations: '返回对话',
  closed_conversations: '已关闭的对话',
  csat_title: '您的对话感觉如何？',
  csat_submitted_title: '您将此对话评价为',
  csat_feedback_placeholder: '告诉我们更多...（可选）',
  follow_up_placeholder: '继续提问…',
  companion_layout_label: '布局',
  companion_layout_floating: '浮动',
  companion_layout_sidebar: '侧边栏',
  companion_layout_fullscreen: '全屏',
  companion_close: '关闭',
  companion_history: '对话历史',
  companion_expand_chat: '展开聊天',
  companion_sidebar_dock_label: '停靠',
  companion_sidebar_side_label: '位置',
  companion_sidebar_left: '左侧',
  companion_sidebar_right: '右侧',
  companion_resize_chat: '调整聊天大小',
  scroll_to_bottom: '滚动到底部',
  thinking: '思考中…',
  running: '运行中…',
  steps: '步骤',
  step_arguments: '参数',
  step_result: '结果',
  attach_files: '附加图片、视频、PDF 或电子表格（最大 25 MB）',
  mark_page_active: '点击页面上的任意内容进行标记 — 按 Esc 取消',
  mark_page: '标记页面上的内容以便就此提问',
  stop_response: '停止回答',
  copy_reply: '复制回复',
  mentions_empty: '没有匹配项',
  copied: '已复制',
  send_message: '发送消息',
  upload_failed: '上传失败：{error}',
  remove_attachment: '移除附件',
  json_no_items: '没有项目',
  json_no_data: '没有数据',
  json_no_chart_data: '没有可用于图表的数据',
  json_unsupported: '不支持：{type}',
  json_see_less: '收起',
  json_phone_agent: '电话客服',
  json_phone_agent_test: '通过网页测试',
  page_context_remove: '移除页面上下文',
  json_see_more: '再显示 {count} 项',
  queued_label: '{count} 排队中',
  remove_queued_message: '从队列中移除消息',
  send_queued_now: '立即发送队列中的消息',
  turn_failed_message: '出现问题，未收到回答。',
  turn_failed_retry: '重试',
  page_mark_hint: '点击任意内容进行标记',
  page_mark_escape: 'Esc',
  page_mark_shape_box: '方框',
  page_mark_shape_circle: '圆形',
  page_mark_shape_arrow: '箭头',
  page_mark_shape_bracket: '括号',
  page_mark_shape_underline: '下划线',
  page_mark_shape_highlight: '高亮',
  page_mark_shape_strike_through: '删除线',
  page_mark_shape_crossed_off: '叉号',
  page_mark_shape_aria: '标记形状：{shape}',
  page_mark_note_placeholder: '添加备注…（按 Enter 附加）',
  page_mark_attach: '附加标记',
  page_mark_remove: '移除{label}',
  page_mark_region: '已标记区域',
  page_mark_default_message: '这是什么？',
  file_rejected: '不支持该文件类型，或文件过大。',
  dictate: '语音输入',
  stop_dictation: '停止语音输入',
  dictation_mic_blocked: '请允许访问麦克风以使用语音输入',
  dictation_unavailable: '语音输入暂时不可用',
  questions_back: '返回',
  questions_next: '下一步',
  questions_send: '发送',
  questions_type_answer: '我自己输入',
  questions_answer_placeholder: '输入你的回答…',
  close_conversation_title: '结束对话',
  close_conversation_description: '确定要结束此对话吗？',
  close_conversation_cancel: '否',
  close_conversation_confirm: '是',
  dialog_close: '关闭',
  zoom_in: '放大',
  zoom_out: '缩小',
  reset_zoom: '重置缩放',
  support_chat_aria_label: '支持对话',
};
